<template>
  <div class="teamBuildingQuote">
    <heads></heads>
    <div class="container">
      <div>
        <div class="container-bottom">
          <div>
          <div class="persontable">
            <table>
              <tr>
                <td class="people">
                  <div class="left"> <span>人数:</span>
                  <el-input v-model.number="peopleNumber" type="number" @input="changePeopleNumber">
                    <template slot="append">人</template>
                  </el-input>
                  <div class="avg-price">人均价格:{{ avgPrice }}元</div>
                </div>
                  <div class="middle">标题:{{title}}</div>     
                  <div class="right">编号:{{sn}} </div>
                </td>
              </tr>
            </table>
            </div>
            <div class="three notes_text" id="three" ref="three" v-if="form.isDynamicPrice == 'N'">
                <div class="large-title">
                  <span class="outside-dot"></span>
                  <span class="inner-dot"></span>
                  <span class="inner-title">费用说明</span>
                  <span class="inner-dot"></span>
                  <span class="outside-dot"></span>
                </div>
                <table>
                  <thead>
                    <tr>
                      <td>费用包含</td>
                      <td>费用不含</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-html="form.fee">
                      </td>
                      <td v-html="form.feeWithout">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="four notes_text" id="four" ref="four" v-if="form.isDynamicPrice == 'N'">
                <div class="large-title">
                  <span class="outside-dot"></span>
                  <span class="inner-dot"></span>
                  <span class="inner-title">预定须知</span>
                  <span class="inner-dot"></span>
                  <span class="outside-dot"></span>
                </div>
                <div
                  class="four-detail"
                  v-html="form.bookingInformation"
                >
                </div>
              </div>
              <div class="five notes_text" id="five" ref="five" v-if="form.isDynamicPrice == 'N'">
                <div class="large-title">
                  <span class="outside-dot"></span>
                  <span class="inner-dot"></span>
                  <span class="inner-title">温馨提示</span>
                  <span class="inner-dot"></span>
                  <span class="outside-dot"></span>
                </div>
                <div class="five-detail" v-html="form.tip">
                </div>
              </div>
      <el-form :model="form" label-width="0px" v-if="form.isDynamicPrice == 'Y'"> 
  <el-table
    :data="form.quoteInformationList"
    class="quoteTable"
    id="quoteTable"
    row-height="10"
    style="width: 100%"
    :span-method="mergeCell"
    :header-cell-style="{color: '#ffffff',
    fontSize: '18px', fontWeight: 700, backgroundColor: '#359FF8'}"
    :summary-method="getSummaries"
    show-summary
    border>
    <el-table-column
      prop="itemName"
      label="费用名称"
      align="center"
      width="160"> 
      <template slot-scope="scope">
        <el-form-item :prop="'quoteInformationList.' + scope.$index + '.selectResult.quoteSetIdList'">
      <div v-if="scope.row.quoteSets && scope.row.quoteSets.length>0">
        <div v-if="scope.row.selectType == 0"> 
          <span>
            {{ scope.row.quoteSets[0].name }}
          </span>
        </div>
        <div v-if="scope.row.selectType == 1" class="quoteSetIdList">
            <el-checkbox-group v-model="scope.row.selectResult.quoteSetIdList" >
            <el-checkbox v-for="item in scope.row.quoteSets" :key="item.id" :label="item.id" @change="changeFeeName(scope.$index,item.id)">
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </el-form-item>
      </template>
    </el-table-column>
    <el-table-column
      prop="unitPrice"
      label="单价"
      align="center">
      <template slot-scope="scope">
        <el-form-item :prop="'quoteInformationList.' + scope.$index + '.selectResult.unitPrice'">
        <div v-if="scope.row.quoteSets && scope.row.quoteSets.length>0">
          <div v-if="scope.row.selectType == 1">
            <div v-for="item in scope.row.quoteSets" :key="item.id">
              <div v-if="item.id ==  scope.row.selectResult.quoteSetIdList[0]">
                <el-checkbox-group v-model="scope.row.selectResult.unitPriceIdList" >
                  <el-checkbox v-for="item2 in item.tbQuotePriceList" :key="item2.id" :label="item2.id" @change="changeUnitPrice(scope.$index,item2.id)">
                    {{ item2.priceName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div v-if="scope.row.selectType == 0">
                <el-checkbox-group v-model="scope.row.selectResult.unitPriceIdList">
                  <el-checkbox v-for="item2 in scope.row.quoteSets[0].tbQuotePriceList" :key="item2.id" :label="item2.id" @change="changeUnitPrice(scope.$index,item2.id)">
                    {{ item2.priceName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
        </div>
      </el-form-item>
      </template>
    </el-table-column>
    <el-table-column
      prop="num"
      align="center"
      width="130"
      label="数量">
      <template slot-scope="scope">
        <el-form-item :prop="'quoteInformationList.' + scope.$index + '.selectResult.quantity'">
          <el-input v-model.number="scope.row.selectResult.quantity" @blur="changNum(scope.$index)" type="number" />
        </el-form-item>
      </template>
    </el-table-column>
    <el-table-column
      prop="price"
      align="center"
      label="价格"
      width="130">
      <template slot-scope="scope">
        <div v-if="scope.row.selectResult.unitPriceIdList && scope.row.selectResult.unitPriceIdList.length>0">
          {{ scope.row.selectResult.quantity * scope.row.selectResult.unitPrice }}
        </div>
        <div v-else>
          {{ 0 }}
        </div>
      </template>   
    </el-table-column> 
    <el-table-column
      fixed="right"
      align="center"
      label="说明"
      width="100">
      <template slot-scope="scope">
        <el-button @click="showFeeRemark(scope.$index)" type="text" size="small">查看</el-button>
      </template>
    </el-table-column>
  </el-table>
</el-form>
          </div>
          <div class="footer-button" v-if="form.isDynamicPrice == 'Y'">
            <el-button   @click="resetData">重置</el-button>
            <el-button  type="primary" @click="saveQuote">保存</el-button>
          </div>
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
    <quickContact :message="quickContactMessage"></quickContact>
    <el-dialog title="备注" :visible.sync="requireDialogVisible" width="30%" top="15%" custom-class="remark-dialog">
      <div class="remark" v-html="showRemark"></div>
    </el-dialog>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import axios from "axios";
import qs from "qs";
import {deepClone} from "@/util/util.js";
import wxShare from "@/common/wx_share.js";
export default {
  name: "teamBuildingQuote",
  data() {
    return {
      content: "",     
      loading: false,
      
      tbId:'',
      numberMin:0,
      numberMax:0,
      peopleNumber:0,
      form:{
      // 报价信息
      quoteInformationList: [],
      time:null,
      fee:null,
      isDynamicPrice:null,
      },
      quickContactMessage:{
        type:1
      },
      // 规则
      rules:{

      },
      title:'报名信息',
      // 显示提示框
      requireDialogVisible:false,
      sumPrice:0,
      showRemark:"",
      // 重置的form
      resetForm:{
        peopleNumber:null,
        form:null,
        numberMax:null,
        numberMin:null,
      },
      // 编号
      sn:'',
      sourceNumberMin:0,
      avgPrice:0,
    };
  },
  components: {
    heads,
    homeFoots,
    quickContact
  },
  computed: {

  },
  methods: {
    deepClone,
    // 合并单元格
    mergeCell() {
        setTimeout(() => {
        　　if (this.$el.querySelector('#quoteTable')) {
         　　 const cells = document.querySelectorAll('#quoteTable .el-table__footer-wrapper tr>td');
         　　 cells[0].colSpan = 1
         　　 cells[1].colSpan = 1
              cells[1].style.textAlign = 'center';
         　　 cells[2].colSpan = 3
              cells[2].style.textAlign = 'center';
         　　 cells[3].style.display = 'none'
              cells[4].style.display = 'none'
         　　 
       　　   
       　　 }
      　　}, 50)
      },
    // 点击展示费用 备注
    showFeeRemark(index){
      this.requireDialogVisible = true;
      let quoteSets = this.form.quoteInformationList[index].quoteSets;
      let selectQuoteSetId = this.form.quoteInformationList[index].selectResult.quoteSetIdList[0];
        quoteSets.forEach((quoteSet)=>{
                if(quoteSet.id == selectQuoteSetId){
                  this.showRemark = quoteSet.remark;
                }
        })
    },
    // 统计
    getSummaries(param){
      const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '费用总计';
            return;
          }else if(index === 1) {
            sums[index] = (this.sumPrice/this.peopleNumber).toFixed(2)
            if(!this.sumPrice || !sums[index]){
              sums[index] = 0
            }
            this.avgPrice = sums[index];
            sums[index] = '人均价格:'+ sums[index] +"元";
            return;
          }else if(index === 2){
            this.form.quoteInformationList.forEach((quoteInformation)=>{
              if(quoteInformation.selectResult.unitPrice && quoteInformation.selectResult.quantity){
                if(!sums[index]){
                  sums[index] = 0
                }
                sums[index] += quoteInformation.selectResult.unitPrice * quoteInformation.selectResult.quantity
              }
            })
            this.sumPrice = sums[index];
            if(sums[index] == undefined){
              sums[index] = 0;
            }
            sums[index] = '总计:'+sums[2] +' 元';
            return;
          }else{
          }
        });

        return sums;
    },

    // 修改费用名称
    changeFeeName(index,quoteSetId){
        if(this.form.quoteInformationList[index].selectResult.quoteSetIdList.length > 0){
          this.form.quoteInformationList[index].selectResult.quoteSetIdList = [quoteSetId]
        }else{
           this.form.quoteInformationList[index].selectResult.quoteSetIdList = [quoteSetId];
           return;
        }
        // 费用名称改变之后需要修改单价项
        let quoteSets = this.form.quoteInformationList[index].quoteSets;
        let selectQuoteSet = {};
        quoteSets.forEach((quoteSet)=>{
                if(quoteSet.id == quoteSetId){
                  selectQuoteSet = quoteSet;
                }
        })
        if(selectQuoteSet.tbQuotePriceList){
          let selectQuotePrice = null;
          let isFind = false;
          selectQuoteSet.tbQuotePriceList.forEach((tbQuotePrice)=>{
                if(tbQuotePrice.isDefault == "Y" && !selectQuotePrice){
                  isFind = true;
                  this.form.quoteInformationList[index].selectResult.unitPrice = tbQuotePrice.price;
                  this.form.quoteInformationList[index].selectResult.unitPriceIdList = [tbQuotePrice.id];
                  this.form.quoteInformationList[index].selectResult.unitPriceId = tbQuotePrice.id;
                }
          })
          if(!isFind){
            this.form.quoteInformationList[index].selectResult.unitPrice = 0;
            this.form.quoteInformationList[index].selectResult.unitPriceIdList = [];
            this.form.quoteInformationList[index].selectResult.unitPriceId = tbQuotePrice.id;
          }
        }
        this.$forceUpdate();
    },
    // 修改单价选项
    changeUnitPrice(index,unitPriceId){
      this.$nextTick(()=>{
        //  console.log("this.form.quoteInformationList[index].selectResult1",this.form.quoteInformationList[index].selectResult)
          let unitPriceIdList = this.form.quoteInformationList[index].selectResult.unitPriceIdList;
          const preUnitPriceId = this.form.quoteInformationList[index].selectResult.unitPriceId;
          let quoteSetIdList = this.form.quoteInformationList[index].selectResult.quoteSetIdList;
          let quoteSets = this.form.quoteInformationList[index].quoteSets;
          let selectQuoteSet = {};
            if(quoteSets && quoteSetIdList && quoteSetIdList.length>0){
              quoteSets.forEach((quoteSet)=>{
                if(quoteSet.id == quoteSetIdList[0]){
                  selectQuoteSet = quoteSet;
                }
              })
              if(unitPriceIdList && unitPriceIdList.length>1){
                this.form.quoteInformationList[index].selectResult.unitPriceIdList = [unitPriceId]
            }
            if(unitPriceIdList.length == 0) {
              this.form.quoteInformationList[index].selectResult.unitPriceIdList = []
              this.form.quoteInformationList[index].selectResult.unitPrice = 0;
              this.form.quoteInformationList[index].selectResult.unitPriceId = null
            }else{
              this.form.quoteInformationList[index].selectResult.unitPriceId = unitPriceIdList[0];
              if(selectQuoteSet.tbQuotePriceList && selectQuoteSet.tbQuotePriceList.length>0){
                    selectQuoteSet.tbQuotePriceList.forEach((tbQuotePrice)=>{
                 if(tbQuotePrice.id == unitPriceId){
                   this.form.quoteInformationList[index].selectResult.unitPrice = tbQuotePrice.price;
                 }
              })
            } 
            // console.log("preIsNull",preIsNull)
             // 重新计算数量[从无到有]
             if(!preUnitPriceId){
              this.computerNum(index,1);
             }
            }
            }
            
        })
    },
    // 重新计算数量
    computerNum(index,changeMethod){
      const type = this.form.quoteInformationList[index].type
      // 找到当前已选中的价格
      let quoteSets = this.form.quoteInformationList[index].quoteSets
      let quantity = -1;
      let priceType =  quoteSets[0].priceType;
      console.log("computerNum")
      if(this.peopleNumber.length < 1){
        return;
      }
      switch(type){
        case "jiaotong": 
         const tbQuotePriceList = quoteSets[0].tbQuotePriceList;
         let targetQuotePrice = null
         let jiaotongTargetQuantity = null;
         let lingduiQuantity = 0;
          if(changeMethod == 1){   
            if(priceType == '1'){
              jiaotongTargetQuantity = this.peopleNumber;
            }else if(priceType == '2'){
              const unitPriceId = this.form.quoteInformationList[index].selectResult.unitPriceIdList[0];
              tbQuotePriceList.forEach((tbQuotePrice)=>{
                 if(tbQuotePrice.id == unitPriceId){
                  targetQuotePrice = tbQuotePrice
                 }
              })
              if(targetQuotePrice && targetQuotePrice.maxNum && targetQuotePrice.maxNum>0){
                jiaotongTargetQuantity = Math.ceil(this.peopleNumber/targetQuotePrice.maxNum)
              } 
            }
             lingduiQuantity = jiaotongTargetQuantity;
             this.form.quoteInformationList[index].selectResult.quantity = jiaotongTargetQuantity; 
          }else{ 
            let sumPrice = 0;
            let targetUnitPriceId = null;
            let targetUnitPrice = null;
            if(priceType == '1'){
                tbQuotePriceList.forEach((tbQuotePrice)=>{
                  console.log("tbQuotePrice.maxNum",tbQuotePrice.maxNum)
                  if(tbQuotePrice && tbQuotePrice.maxNum && tbQuotePrice.maxNum>0){
                    let thisQuantity = Math.ceil(this.peopleNumber/tbQuotePrice.maxNum)
                    let thisUnitPrice = tbQuotePrice.price;
                    if(sumPrice == 0 || sumPrice> thisQuantity * thisUnitPrice ){
                      sumPrice = thisQuantity * thisUnitPrice;
                      targetUnitPriceId = tbQuotePrice.id;
                      targetUnitPrice = thisUnitPrice;
                    }
                  }
                })
             jiaotongTargetQuantity = this.peopleNumber;
            }else if(priceType == '2'){
            tbQuotePriceList.forEach((tbQuotePrice)=>{
              console.log("tbQuotePrice.maxNum",tbQuotePrice.maxNum)
              if(tbQuotePrice && tbQuotePrice.maxNum && tbQuotePrice.maxNum>0){
                let thisQuantity = Math.ceil(this.peopleNumber/tbQuotePrice.maxNum)
                let thisUnitPrice = tbQuotePrice.price;
                if(sumPrice == 0 || sumPrice> thisQuantity * thisUnitPrice ){
                  sumPrice = thisQuantity * thisUnitPrice;
                  targetUnitPriceId = tbQuotePrice.id;
                  targetUnitPrice = thisUnitPrice;
                  jiaotongTargetQuantity = thisQuantity;
                  lingduiQuantity = jiaotongTargetQuantity;
                }
              }
            })
          }
            this.form.quoteInformationList[index].selectResult.quantity = jiaotongTargetQuantity; 
            this.form.quoteInformationList[index].selectResult.unitPrice = targetUnitPrice;              
            this.form.quoteInformationList[index].selectResult.unitPriceIdList = [targetUnitPriceId];
            this.form.quoteInformationList[index].selectResult.unitPriceId = targetUnitPriceId;
          }
          // 更新领队数
          // 判断前面是否车费
          if(priceType == '2'){
            let isFind = false;
            for (let i = 0; i < index; i++) {
              const quoteInformation = this.form.quoteInformationList[index];
              if(quoteInformation.type == "jiaotong"){
                isFind = true;
              }
            }
            if(!isFind){
              for (let i = 0; i < this.form.quoteInformationList.length; i++) {
                const quoteInformation = this.form.quoteInformationList[i];
                if(quoteInformation.type == "lingdui"){
                  this.form.quoteInformationList[i].selectResult.quantity = lingduiQuantity;
                }
              }
            }
            break;
          }
        case "canyin": 
          quantity = 0;
          if(priceType == '2'){
            quantity = Math.floor(this.peopleNumber/10)
            const remainder = this.peopleNumber%10
            if(remainder>=5){
              quantity += 1;
            }
          }else if(priceType == '1'){
            quantity = this.peopleNumber;
          }
          this.form.quoteInformationList[index].selectResult.quantity = quantity; 
          break;
        case "jiudian": 
          if(priceType == '1'){
            quantity = Math.ceil(this.peopleNumber/2);
          }else if(priceType == '2'){
            if(changeMethod != 1){  
                this.changePriceItem(index,quoteSets[0]);
            }
            quantity = 1;
          }
          this.form.quoteInformationList[index].selectResult.quantity = quantity; 
          break;
        case "lingdui": 
            // 找到车费
            for (let i = 0; i < this.form.quoteInformationList.length; i++) {
              const quoteInformation = this.form.quoteInformationList[i];
              if(quoteInformation.type == "jiaotong" && quoteInformation.priceType == '2'){
                this.form.quoteInformationList[index].selectResult.quantity = this.form.quoteInformationList[i].selectResult.quantity
                break;
              }
            } 
         break;  
        case "zhuti": 
        case "yule": 
        case "jingdian": 
        case "fuwu": 
            if(priceType == '1'){
              quantity = this.peopleNumber;
            }else if(priceType == '2'){
              if(changeMethod != 1){  
                this.changePriceItem(index,quoteSets); 
              }
              quantity = 1;
            }
      this.form.quoteInformationList[index].selectResult.quantity = quantity;   
      break; 
    }
    },
    // 调整价格选择
    changePriceItem(quoteInformationIndex,quoteSets){
      if(quoteSets){
        let targetUnitPriceId = null;
        let targetUnitPrice = null;
        for (let index = 0; index < quoteSets.length; index++) {
          const quoteSet = quoteSets[index];
          const tbQuotePriceList = quoteSet.tbQuotePriceList;
            let itemUnitPriceId = null;
            let itemUnitPrice = null;
            let MostMaxNum = -1;
            let MostMinNum = -1;
            let minUnitPriceId = null;
            let minUnitPrice = null;
            let maxUnitPriceId = null;
            let maxUnitPrice = null;   
            let sumPrice = -1;
            let isFind = false;
            if(tbQuotePriceList && tbQuotePriceList.length > 0){
                for (let j = 0; j < tbQuotePriceList.length; j++) {
                  const quotePrice = tbQuotePriceList[j];
                  let thisUnitPrice = quotePrice.price;
                  if(quotePrice.maxNum && quotePrice.minNum){
                    if(quotePrice.maxNum>= this.peopleNumber && quotePrice.minNum< this.peopleNumber){
                      sumPrice = thisUnitPrice
                      if(itemUnitPrice == null || sumPrice < itemUnitPrice){
                        itemUnitPrice = thisUnitPrice;
                        itemUnitPriceId = quotePrice.id;
                      }
                      isFind = true;
                    }
                    if(MostMinNum == -1 || MostMinNum > quotePrice.minNum){
                      minUnitPriceId = quotePrice.id;
                      minUnitPrice = thisUnitPrice;
                      MostMinNum = quotePrice.minNum;
                    }
                    if(MostMaxNum == -1 || MostMaxNum < quotePrice.maxNum){
                      maxUnitPriceId = quotePrice.id;
                      maxUnitPrice = thisUnitPrice;
                      MostMaxNum = quotePrice.maxNum;
                    }
                  }
              }
              if(!isFind){
                if(this.peopleNumber < MostMinNum && minUnitPriceId){
                  itemUnitPriceId = minUnitPriceId;
                  itemUnitPrice = minUnitPrice;
                }
                if(this.peopleNumber > MostMaxNum && maxUnitPriceId){
                  itemUnitPriceId = maxUnitPriceId;
                  itemUnitPrice = maxUnitPrice;
                }
              }
              if(!targetUnitPriceId || (itemUnitPrice>=0 && itemUnitPrice<targetUnitPrice)){
                targetUnitPriceId = itemUnitPriceId;
                targetUnitPrice = itemUnitPrice;
              }
        }
      }
      if(targetUnitPriceId){
          this.form.quoteInformationList[quoteInformationIndex].selectResult.unitPrice = targetUnitPrice;             
          this.form.quoteInformationList[quoteInformationIndex].selectResult.unitPriceIdList = [targetUnitPriceId];
          this.form.quoteInformationList[quoteInformationIndex].selectResult.unitPriceId = targetUnitPriceId;
      }
     }
    },
     // 人数发生改变
    changePeopleNumber(){
      console.log("chufa")
      if(this.form.isDynamicPrice !='Y'){
        return;
      }
      for (let index = 0; index < this.form.quoteInformationList.length; index++) {
        if(this.form.quoteInformationList[index].selectResult.unitPriceId){
          this.computerNum(index);
        }
      }
    },
    // 将数据保存至cookies
    saveQuote(){
      let newQuote = {
          tbId:this.tbId,
          peopleNumber:this.peopleNumber,
          form:this.form,
          numberMax:this.numberMax,
          numberMin:this.numberMin,
        }
        // console.log("saveQuote -- newQuote",newQuote)
      // 获取cookies
      let quoteList = JSON.parse(localStorage.getItem("quoteList"));
      if(!quoteList){
        quoteList = [newQuote]
      }else{
        let isFind = false;
        for (let index = 0; index < quoteList.length; index++) {
          let quote = quoteList[index];
          if(quote.tbId == newQuote.tbId){
            isFind = true;
            quoteList.splice(index,1,newQuote);
          }
        }
        if(!isFind){
          quoteList.push(newQuote);
        }
      }
      localStorage.setItem("quoteList", JSON.stringify(quoteList));
      this.$message({
                  message:"保存成功",
                  type: "success",
                  duration: 1500,
                  center: true,
      });
    },

    // 从cookies获取报价
    getQuoteFormCookies(){
      let quoteList = JSON.parse(localStorage.getItem("quoteList"));

      if(quoteList){
        for (let index = 0; index < quoteList.length; index++) {
          const quote = quoteList[index];
          console.log("quoteList",quoteList)
          console.log("this.tbId",this.tbId)
          console.log("quote.tbId",quote.tbId)
          if(quote.tbId == this.tbId){
            console.log("quoteList --quote", quote)
            return quote;
          }
        }
      }
        
    },     
    // 重置数据
    resetData(){
      axios
        .get(`/api/tbQuote/`+this.tbId)
        .then((res) => {
          if(res.data &&res.data.code == 200){
              // 从cookies中获取数据
              this.sn = res.data.sn;  
              this.form.quoteInformationList = res.data.list;           
              this.form.time = res.data.time;
              this.form.isDynamicPrice = res.data.isDynamicPrice;
              if(res.data.isDynamicPrice != 'Y'){
                this.avgPrice = res.data.price;
                this.form.fee = res.data.fee;
                this.form.feeWithout = res.data.feeWithout;     
                this.form.bookingInformation = res.data.bookingInformation;     
                this.form.tip = res.data.tip;  
              }
              this.form.quoteInformationList.forEach((quoteItem)=>{
                if(quoteItem){
                   let selectResult = {};
                   selectResult.quoteSetIdList = [],
                   selectResult.quoteSetName = '',
                   selectResult.unitPrice = 0,
                   selectResult.unitPriceIdList = [],
                   selectResult.unitPriceId = null,
                   selectResult.quantity = 0   
                  if(quoteItem.quoteSets && quoteItem.quoteSets.length>0){
                    const quoteSets = quoteItem.quoteSets;
                    if(quoteItem.selectType == '0'){
                      selectResult.quoteSetIdList = [quoteSets[0].id];
                      selectResult.quoteSetName = quoteSets[0].name;
                      quoteSets[0].tbQuotePriceList.forEach(tbQuotePrice => {
                        if(tbQuotePrice.isDefault == 'Y' && quoteSets[0].isDefault == 'Y'){
                          selectResult.unitPriceIdList = [tbQuotePrice.id];
                          selectResult.unitPriceId = tbQuotePrice.id
                          selectResult.unitPrice = tbQuotePrice.price;
                          selectResult.quantity = tbQuotePrice.quantity;
                        }
                      })
                    }else if(quoteItem.selectType == '1'){
                      quoteSets.forEach(quoteSet => {
                        if(quoteSet.isDefault == 'Y'){
                          selectResult.quoteSetIdList = [quoteSet.id];
                          selectResult.quoteSetName = quoteSet.name;
                          quoteSet.tbQuotePriceList.forEach(tbQuotePrice => {
                          if(tbQuotePrice.isDefault == 'Y'){
                            selectResult.unitPriceIdList = [tbQuotePrice.id];
                            selectResult.unitPriceId = tbQuotePrice.id
                            selectResult.unitPrice = tbQuotePrice.price;
                            selectResult.quantity = tbQuotePrice.quantity;
                          }
                      })
                        }
                      });
                    }
                  }
                  this.$set(quoteItem, 'selectResult', selectResult)
                }
              }) 
                this.resetForm.peopleNumber = this.numberMin;
                this.peopleNumber = this.numberMin;
                this.resetForm.form = this.deepClone(this.form);
                this.resetForm.numberMax = this.numberMax;
                this.resetForm.numberMin = this.numberMin;       
              }
          console.log("this.form",this.form)
          this.$forceUpdate();
        }).catch((e)=>{
          console.log("err",e)
        })
    },
    // 获取报价
    getQuote(){
      axios
        .get(`/api/tbQuote/`+this.tbId)
        .then((res) => {
          if(res.data &&res.data.code == 200){
              // 从cookies中获取数据
              const quote = this.getQuoteFormCookies();
              this.sn = res.data.sn;
              // console.log("quote.form",quote.form.time)
              // console.log("form.time",res.data.time)
              if(quote && new Date(quote.form.time).getTime() == new Date(res.data.time).getTime() ){
                console.log("填上cookies数据")
                console.log("quote.form",quote.form)
                this.peopleNumber = quote.peopleNumber;
                this.form = quote.form;
                this.numberMax = quote.numberMax;
                this.numberMin = quote.numberMin;
                this.resetForm.peopleNumber = quote.peopleNumber;
                this.resetForm.form = this.deepClone(quote.form);
                this.resetForm.numberMax = quote.numberMax;
                this.resetForm.numberMin = quote.numberMin;
              }else{         
              this.form.quoteInformationList = res.data.list;           
              this.form.time = res.data.time;
              this.form.isDynamicPrice = res.data.isDynamicPrice;
              if(res.data.isDynamicPrice != 'Y'){
                this.avgPrice = res.data.price;
                this.form.fee = res.data.fee;
                this.form.feeWithout = res.data.feeWithout;     
                this.form.bookingInformation = res.data.bookingInformation;     
                this.form.tip = res.data.tip;  
              }
              console.log("this.form.quoteInformationList",res.data.list)
              console.log("this.form.time",res.data.time)
              this.form.quoteInformationList.forEach((quoteItem)=>{
                if(quoteItem){
                   let selectResult = {};
                   selectResult.quoteSetIdList = [],
                   selectResult.quoteSetName = '',
                   selectResult.unitPrice = 0,
                   selectResult.unitPriceIdList = [],
                   selectResult.unitPriceId = null,
                   selectResult.quantity = 0   
                  if(quoteItem.quoteSets && quoteItem.quoteSets.length>0){
                    const quoteSets = quoteItem.quoteSets;
                    if(quoteItem.selectType == '0'){
                      selectResult.quoteSetIdList = [quoteSets[0].id];
                      selectResult.quoteSetName = quoteSets[0].name;
                      quoteSets[0].tbQuotePriceList.forEach(tbQuotePrice => {
                        if(tbQuotePrice.isDefault == 'Y' && quoteSets[0].isDefault == 'Y' ){
                          selectResult.unitPriceIdList = [tbQuotePrice.id];
                          selectResult.unitPriceId = tbQuotePrice.id;
                          selectResult.unitPrice = tbQuotePrice.price;
                          selectResult.quantity = tbQuotePrice.quantity;
                        }
                      })
                    }else if(quoteItem.selectType == '1'){
                      quoteSets.forEach(quoteSet => {
                        if(quoteSet.isDefault == 'Y'){
                          selectResult.quoteSetIdList = [quoteSet.id];
                          selectResult.quoteSetName = quoteSet.name;
                          quoteSet.tbQuotePriceList.forEach(tbQuotePrice => {
                          if(tbQuotePrice.isDefault == 'Y'){
                            selectResult.unitPriceIdList = [tbQuotePrice.id];
                            selectResult.unitPriceId = tbQuotePrice.id;
                            selectResult.unitPrice = tbQuotePrice.price;
                            selectResult.quantity = tbQuotePrice.quantity;
                          }
                      })
                        }
                      });
                    }
                  }
                  this.$set(quoteItem, 'selectResult', selectResult)
                }
              }) 
                this.resetForm.peopleNumber = this.peopleNumber;
                this.resetForm.form = this.deepClone(this.form);
                this.resetForm.numberMax = this.numberMax;
                this.resetForm.numberMin = this.numberMin;       
              }
          }
          console.log("this.form",this.form)
          this.$forceUpdate();
        }).catch((e)=>{
          console.log("err",e)
        })
    },
  },
  mounted() {
    this.loading = true;
    if(this.$route.query.tbId){
      this.tbId = this.$route.query.tbId
      this.numberMin = this.$route.query.numberMin
      this.sourceNumberMin = this.$route.query.numberMin
      this.numberMax = this.$route.query.numberMax
      this.peopleNumber = this.$route.query.numberMin
      this.title = this.$route.query.title
      this.getQuote();
    }
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
};
</script>

<style scoped>
.container {
  text-align: left;
  margin-bottom: 20px;
  width: 1100px;
}
.container-top {
  min-height: 60px;
  margin-top: 20px;
}
.container-top .title{
  min-height: 60px;
  text-align: center;
}
.container-bottom {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  position: flex;
  padding-bottom: 50px;
}
.quoteSetIdList >>> .el-checkbox{
  margin-right: 0px;
  display: flex;
}
.teamBuildingQuote .quoteSetIdList >>> .el-checkbox{
 /* width: 40px; */
}
.teamBuildingQuote .quoteSetIdList >>> .el-checkbox__label{
 /* width: 40px; */
 display: flex;
 white-space: normal;
}
.teamBuildingQuote  >>> .el-table--border, .el-table--group,
.teamBuildingQuote  >>> .el-table--border th,
.teamBuildingQuote  >>> .el-table--border td  {
  border: 1px solid #C2E2FD;
}
.title{
  font-size: 28px;
  font-weight: 700;
  margin-top: 20px;
  color: #999;
}
.main-title{
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  margin-top: 80px;
}
.tbInfo{
  width: 80%;
}
.quoteTable{
  margin-top: 0px;
}
.header-title{
  background: #359FF8;font-weight: 700;
  color: #fff;
  font-weight: 700;
  text-align: center;
}
.quoteTable >>> .el-table__row .cell{
  color: #000;
}

.quoteTable >>> .el-form-item{
  margin-bottom: 0;
}

/* .quoteTable >>> .tl_table.td{
  padding: 0;
} */

.quoteTable >>> .el-form-item .el-input__inner{
  height: 30px;
  line-height: 30px;
}

.teamBuildingQuote >>> .el-table td{
  padding: 2px 0;
  height: 40px;
  line-height: 40px;
}
.teamBuildingQuote >>> .el-checkbox__label{

}
/* .quoteTable >>> .el-table__footer-wrapper{
  height: 40px;
  line-height: 40px;
} */
.fee-table{
  line-height: 48px;
  /* height: 48px; */
  border: 1px solid #C2E2FD;
  border-top: none;
}
.fee-table .fee-label{
  line-height: 48px;
  height: 48px;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: #fff;
  background: #359FF8;
}
.fee-table .fee-text{
  padding: 0 10px;
}
.persontable{
  /* width: 100%; */
  font-size: 18px;
  font-weight: 700;
  line-height: 48px;
  height: 48px;
  padding-left: 10px;
  border: 1px solid #C2E2FD;;
  margin-top: 20px;
}
.people{
  margin-top: 10px;
  display: flex;
  width: 1080px;
  justify-content: space-between;
}

.people span{
  width: 44px;
  
}

.people .avg-price{
  padding-left:10px;
  
}

.people .left{
  display: flex;  
  flex-wrap: nowrap;
  align-items: center;
  height: 30px;
}
.people .middle, .people .right{
  display: flex;  
  flex-wrap: nowrap;
  align-items: center;
  height: 30px;
  font-size:14px;
  font-weight: bold;
}
.people .middle {
  font-size:16px;
}
.people >>> .el-input-group{
  display: flex;
  align-items: center;
  width: 150px;
}
.people >>> .el-input-group__append, .el-input-group__prepend{
padding: 10px 25px 10px 10px;
}
.persontable   th,
.persontable  td {
  
}
.footer-button{
  position: absolute;
  right: 0;
  bottom: 0px;
}

.teamBuildingQuote>>> .el-dialog__header{

 position: relative;
} 

.teamBuildingQuote>>> .el-dialog__title{
  position: absolute;
  left: 20px;
  font-size: 22px;
}

.remark{
  text-align: left;
}
.notes_text {
  margin: 20px;
}
.notes_text .large-title {
  height: 60px;
  line-height: 60px;
  text-align: center;
  width: 100%;
}

.notes_text .large-title .inner-title {
  display: inline-block;
  font-weight: 700;
  font-size: 30px;
  color: #222;
  letter-spacing: -0.71px;
  padding: 0 19px;
  vertical-align: middle;
}
.notes_text .large-title .outside-dot {
  display: inline-block;
  background: #359ff8;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin: 0 10px;
  vertical-align: middle;
}
.notes_text .large-title .inner-dot {
  display: inline-block;
  background: #359ff8;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  vertical-align: middle;
}

.three table{
  width: 100%;
}
.three table thead{
  width: 100%;
}
.three table thead td {
  color: #222;
  font-size: 18px;
  text-align: center;
  background-color: #c2e2fd;
  padding: 10px;
  width: 50%;
}
.three table tbody td {
  color: #222;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 30px;
  /* text-align: center; */
  background-color: #f8f8f8;
  padding: 10px;
  vertical-align: top;
}
.three table td {
  border: 1px solid #fff;
  width: 50%;
}
.three table tbody td .fee-content-item {
  padding: 10px;
  display: flex;
  flex-direction: row;
}
.three table tbody .fee-content-item span {
  font-weight: 700;
  flex: 1;
  font-size: 14px;
}
.three table tbody .fee-content-item p {
  flex: 4;
  font-size: 14px;
  text-align: left;
}
.three table tbody td .fee-without-item {
  padding: 10px;
  display: flex;
  flex-direction: row;
}
.three table tbody .fee-without-item span {
  position: relative;
  left: -6px;
  top: 6px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #666;
  display: block;
}
.three table tbody .fee-without-item p {
  flex: 4;
  font-size: 14px;
  text-align: left;

}

.three>>> img ,.four-detail>>> img,.five-detail>>> img{
  width: 100%;
}
.three table tbody td >>>ul,.four-detail>>>ul,.five-detail>>>ul{
  padding-left: 20px;
}
.three table tbody td >>>ul li,.four-detail>>>ul li,.five-detail>>>ul li{
  list-style: initial;
}

.four-detail {
  font-size: 14px;
  letter-spacing: 0;
  /* display: flex;
  flex-direction: row; */
}
.four-detail span {
  margin-top: 12px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #359ff8;
  flex: 1;
  display: block;
}
.four-detail p {
  font-size: 14px;
  color: #101010;
  letter-spacing: 0;
  line-height: 30px;
  padding-left: 16px;
  flex: 120;
}
</style>





// WEBPACK FOOTER //
// src/components/teamBuildingview/teamBuildingQuote.vue